import { NAMESPACE } from './constants'

export const user = state => state[NAMESPACE].user
export const status = state => state[NAMESPACE].status
export const error = state => state[NAMESPACE].error
